import { memo } from 'react';
import { formatToStandardDate } from '../utils';
import type { SessionPreviewFooterProps } from './types';
import Badge from '@/components/atoms/Badge/Badge';
import { classnames } from '@/libs/utils';

function SessionPreviewFooter({
  title,
  endTime,
  isCLHomePageEnabled,
  isVideoReadyForPreview,
  contentStatusText
}: SessionPreviewFooterProps) {
  return (
    <div
      className={classnames(
        'flex w-full items-center gap-2 space-x-2 !rounded-b-xl bg-white px-5 py-3.5',
        isCLHomePageEnabled ? '!p-3' : ''
      )}
    >
      <div className="grow truncate">
        <div
          className={classnames('truncate text-left text-sm leading-tight tracking-tight', {
            'mb-[6px] font-medium text-slate-950': isCLHomePageEnabled
          })}
        >
          {title}
        </div>
        <div className="text-left text-xs text-slate-500">{formatToStandardDate(endTime)}</div>
      </div>

      {!isVideoReadyForPreview && (
        <div className="shrink-0">
          <Badge data-testid="session-badge" variation="gray">
            {contentStatusText}
          </Badge>
        </div>
      )}
    </div>
  );
}

export default memo(SessionPreviewFooter);
